<cc-navigation-bar
    [lobbyType]="lobbyType"
    [categoryRoute]="categoryRoute"
    [lobbyProduct]="lobbyProduct"
    [productOverride]="productOverride"
    [stickyInputQueryElement]="stickyInputQueryElement"
    [extendMenuDslEvalCompleted]="extendMenuDslEvalCompleted" />
